/**
 * Loads Designer config-tree themes for the selected connection into the App
 * theme registry (source=config). Renders nothing.
 */
import { useEffect } from 'react'
import { useConnection } from '@/app/contexts/ConnectionContext'
import { configService } from '@/designer/services/configService'
import { useThemeContext } from '@/theme'
import { logger } from '@/utils/logger'

export function ConnectionThemesSync() {
  const { selectedConnection } = useConnection()
  const { applyConnectionThemes } = useThemeContext()
  const connectionId = selectedConnection?.id ?? null

  useEffect(() => {
    let cancelled = false
    if (!connectionId) {
      applyConnectionThemes(null, [])
      return
    }
    void configService
      .getTree(connectionId)
      .then((tree) => {
        if (!cancelled) applyConnectionThemes(connectionId, tree)
      })
      .catch((e) => logger.warn('ConnectionThemesSync: getTree failed', e))
    return () => {
      cancelled = true
    }
  }, [connectionId, applyConnectionThemes])

  return null
}
